import { AUTH_DEMO_LOG_IN } from '../actionTypes';

const GATEWAY_URL = process.env.API_GATEWAY_URL;

export function demoLogIn(token, demoInfo) {
  return {
    type: AUTH_DEMO_LOG_IN,
    meta: { crossTab: false },
    payload: {
      token,
      email: demoInfo?.email || 'demo@redflagai.co',
      firstName: demoInfo?.fullName?.split(' ')[0] || 'Demo',
      lastName: demoInfo?.fullName?.split(' ').slice(1).join(' ') || 'User',
    },
  };
}

export function fetchDemoLinkStatus(token) {
  return async () => {
    const response = await fetch(`${GATEWAY_URL}/api/auth/demo/${token}/status`);
    if (!response.ok) throw new Error('Demo link not found or expired');
    return response.json();
  };
}

export function submitDemoInfo(token, formData) {
  return async (dispatch) => {
    const response = await fetch(`${GATEWAY_URL}/api/auth/demo/${token}/collect`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || 'Failed to submit info');
    }
    const data = await response.json();
    const accessToken = response.headers.get('Authorization')?.replace('Bearer ', '');
    if (accessToken) dispatch(demoLogIn(accessToken, formData));
    return data;
  };
}

export function fetchAdminDemoLinks(adminToken) {
  return async () => {
    const response = await fetch(`${GATEWAY_URL}/api/auth/demo/links`, {
      headers: { Authorization: `Bearer ${adminToken}` },
    });
    if (!response.ok) throw new Error('Failed to fetch demo links');
    return response.json();
  };
}

export function createAdminDemoLink(adminToken, days, name) {
  return async () => {
    const response = await fetch(`${GATEWAY_URL}/api/auth/demo/links`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminToken}`,
      },
      body: JSON.stringify({ days, name }),
    });
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || 'Failed to create demo link');
    }
    return response.json();
  };
}

export function fetchAdminDemoLinkById(adminToken, id) {
  return async () => {
    const response = await fetch(`${GATEWAY_URL}/api/auth/demo/links/${id}`, {
      headers: { Authorization: `Bearer ${adminToken}` },
    });
    if (!response.ok) throw new Error('Failed to fetch demo link');
    return response.json();
  };
}

export function updateAdminDemoLink(adminToken, id, updates) {
  return async () => {
    const response = await fetch(`${GATEWAY_URL}/api/auth/demo/links/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminToken}`,
      },
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Failed to update demo link');
    return response.json();
  };
}

export function deleteAdminDemoLink(adminToken, id) {
  return async () => {
    const response = await fetch(`${GATEWAY_URL}/api/auth/demo/links/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${adminToken}` },
    });
    if (!response.ok) throw new Error('Failed to delete demo link');
  };
}
